import get from 'lodash/get';

/* 
          If transferData already exists, no new transfer should be created.
          The user will just be redirected to the wire instructions or to ACH based
          on the radio check
        */
export default function directToPaymentSystem(transferData, radioCheck, props) {
  if (transferData) {
    switch (radioCheck.method) {
      case 'ACH':
        props.history.push('/create-account/step-select-account', {
          existingTransferId: transferData.id,
        });
        break;
      case 'Wire':
        props.history.push(
          `/create-account/wiring-instructions?transfer_id=${
            transferData.id
          }&tenant_id=${get(props, 'tenant._id')}`,
        );
        break;
      default:
        throw new Error(`Unknown payment method ${radioCheck.method}`);
    }
  }
}
